import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useTranslation } from 'react-i18next';

const { FiCamera, FiUsers, FiCheckCircle, FiDollarSign, FiStar, FiClock, FiTrendingUp, FiBarChart3, FiHome, FiMessageCircle, FiPieChart, FiShield, FiTarget, FiAward, FiCalendar, FiGlobe, FiSettings, FiTool, FiHeadphones, FiMonitor, FiPhone, FiMail } = FiIcons;

const Services = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="bg-brand-blue py-24 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-brand-gold rounded-full blur-[120px]"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-gold rounded-full blur-[120px]"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-6"
          >
            <span className="bg-brand-gold text-white px-5 py-2 rounded-full text-xs font-black uppercase tracking-[0.3em]">
              {t('Certificazione Corporate')}
            </span>
          </motion.div>
          
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-4xl md:text-7xl font-black mb-8 leading-tight"
          >
            {t('Gestione Istituzionale')} <br/>
            <span className="text-brand-gold uppercase">{t('di Successo')}</span>
          </motion.h1>
          
          <p className="text-xl md:text-2xl text-brand-silver mb-12 max-w-4xl mx-auto leading-relaxed font-light">
            {t('Trasformiamo il tuo immobile in una rendita passiva sicura e ottimizzata con standard internazionali di lusso e precisione data-driven.')}
          </p>
        </div>
      </section>

      {/* Property Showcase section updated with new logo/brand feel */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="rounded-[2.5rem] overflow-hidden shadow-2xl"
          >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
              <img src="https://media-manager-c.questera.ai/greta-media/32dc413054558dbd6d4d3c4a3e2032d0a5a88f3a3f9e6c5dd10a15135c65ae90de62d22e50b183c419625584e3716ff8/images/aW1hZ2UvanBlZw==/d31c996d43abab438db6a2eaffc18e56.jpg" alt="Portfolio 1" className="w-full h-80 object-cover" />
              <img src="https://media-manager-c.questera.ai/greta-media/32dc413054558dbd6d4d3c4a3e2032d0a5a88f3a3f9e6c5dd10a15135c65ae90de62d22e50b183c419625584e3716ff8/images/aW1hZ2UvanBlZw==/039aeb01ebaeb4b3127d00de61ddb802.jpg" alt="Portfolio 2 (Bosco Verticale)" className="w-full h-80 object-cover" />
              <img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753288194892-Loft-in-vendita-milano-608858958.jpg" alt="Portfolio 3" className="w-full h-80 object-cover" />
            </div>
            <div className="bg-brand-gold text-white p-8 text-center">
              <h3 className="text-2xl font-black uppercase tracking-widest mb-2">150+ {t('Asset in Gestione Attiva')}</h3>
              <p className="text-lg font-medium text-white/90">{t('Rating medio 4.9/5 • Tasso occupazione 85% • ROI garantito')}</p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Final CTA updated to remove Elvira image */}
      <section className="py-24 bg-brand-blue relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <div className="mb-12">
            <img 
              src="https://i.imghippo.com/files/DqZX5957Q.png" 
              alt="Castello SRL Corporate" 
              className="h-32 w-auto brightness-0 invert mx-auto mb-10" 
            />
            <h2 className="text-4xl md:text-6xl font-black text-white mb-8 uppercase tracking-tight">{t('Inizia la tua scalata oggi')}</h2>
            <p className="text-xl text-brand-silver mb-12 max-w-3xl mx-auto leading-relaxed font-light">
              {t('Unisciti ai proprietari che hanno scelto Castello SRL per massimizzare i loro investimenti immobiliari. Consulenza rapida, gestione totale, risultati certificati.')}
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row justify-center gap-6 mb-12">
            <Link 
              to="/simulatore" 
              className="bg-brand-gold text-white px-12 py-6 rounded-2xl text-xl font-black hover:bg-white hover:text-brand-blue transition-all shadow-2xl"
            >
              {t('SIMULA RENDITA')}
            </Link>
            <Link 
              to="/contatti" 
              className="bg-transparent text-white border-2 border-brand-gold px-12 py-6 rounded-2xl text-xl font-black hover:bg-brand-gold transition-all"
            >
              {t('PARLA CON IL TEAM')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;